/* ---------------------------------------------------------------------
 *                               Constant
 * --------------------------------------------------------------------- */

/* -------------------------------------------
 *                 Server
 * -------------------------------------------*/

/**
 * 主机名和端口号
 * @type {string}
 */
export const HOST_NAME_PORT = "https://fouradd.cn:8443";

// export const HOST_NAME_PORT = "http://47.99.162.205:8090";

/**
 * 超时时间
 * @type {number}
 */
export const TIMEOUT = 200000;

/**
 * 授权类型 - 密码
 * @type {string}
 */
export const GRANT_PASSWORD = "pwd";

/**
 *  授权类型 - 验证码
 *  @type {string}
 */
export const GRANT_SMS = "sms"

/**
 * 客户端ID
 * @type {string}
 */
export const CLIENT_ID = "e5cd7e4891bf95d1d19206ce24a7b32e";

/**
 * 租户ID
 * @type {string}
 */
export const TENANT_ID = "000000";

/* ---------------------------------------------------------------------
 *                                API Path
 * --------------------------------------------------------------------- */

/* -------------------------------------------
 *                    SSE
 * -------------------------------------------*/
/**
 * @type {string}
 */
export const SSE_PATH = "";

/* -------------------------------------------
 *                    SMS
 * -------------------------------------------*/

/**
 * 请求验证码
 * @type {string}
 */
export const SMS_PATH = "/sms/send";

/* -------------------------------------------
 *                    Auth
 * -------------------------------------------*/

/**
 * 登录路径
 * @type {string}
 */
export const LOGIN_PATH = "/auth/login";

/**
 * 注册路径
 * @type {string}
 */
export const REGISTER_PATH = "/auth/register";

/**
 * 重置密码路径
 * @type {string}
 */
export const RESET_PASSWORD_PATH = "/auth/resetPwd";

/* -------------------------------------------
 *                    Chat
 * -------------------------------------------*/

/**
 * 聊天路径
 * @type {string}
 */
export const CHAT_PATH = "/chat/stream"